import { I } from "../Icons.jsx";
import Btn from "../ui/Btn.jsx";
import Eyebrow from "../ui/Eyebrow.jsx";
import Chip from "../ui/Chip.jsx";
import { inputStyle } from "../ui/styles.js";

export function GuestPoolTop({
  filteredUnassigned,
  unassigned,
  search, setSearch,
  addingPerson, setAddingPerson,
  newPerson, setNewPerson,
  onAddPerson,
  onDragOver, onDrop,
  selectedP,
  onPersonClick, onPersonDragStart,
}) {
  return (
    <div onDragOver={onDragOver} onDrop={onDrop} style={{
      padding: "16px 32px",
      borderBottom: "1px solid var(--line)",
      background: "var(--paper-1)",
      flexShrink: 0,
    }}>
      <div style={{ display: "flex", alignItems: "center", gap: 14, marginBottom: 10, flexWrap: "wrap" }}>
        <Eyebrow>Still to seat · {unassigned.length}</Eyebrow>
        <div style={{ flex: 1 }} />
        <div style={{
          display: "inline-flex", alignItems: "center", gap: 8,
          padding: "6px 10px", borderRadius: 8,
          border: "1px solid var(--line-2)", background: "var(--paper-0)",
          width: 220,
        }}>
          <I.search size={13} stroke="var(--ink-3)" />
          <input
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="Search guests, companies…"
            style={{
              flex: 1, border: "none", background: "transparent", outline: "none",
              fontSize: 12.5, color: "var(--ink)", fontFamily: "var(--ui)",
              minWidth: 0,
            }}
          />
        </div>
        {!addingPerson ? (
          <Btn variant="dashed" size="sm" icon={I.plus} onClick={() => setAddingPerson(true)}>Add guest</Btn>
        ) : (
          <>
            <input
              autoFocus
              value={newPerson}
              onChange={(e) => setNewPerson(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") onAddPerson();
                else if (e.key === "Escape") { setAddingPerson(false); setNewPerson(""); }
              }}
              placeholder="Full name"
              style={{ ...inputStyle, width: 200, marginBottom: 0 }}
            />
            <Btn variant="primary" size="sm" onClick={onAddPerson}>Add</Btn>
            <Btn variant="quiet" size="sm" onClick={() => { setAddingPerson(false); setNewPerson(""); }}>Cancel</Btn>
          </>
        )}
      </div>
      <div style={{
        display: "flex", flexWrap: "wrap", gap: 5,
        maxHeight: 92, overflow: "auto", paddingRight: 4,
      }}>
        {filteredUnassigned.map(p => (
          <Chip
            key={p.id}
            person={p}
            isSelected={selectedP === p.id}
            isHost={false}
            showHosts={false}
            onClick={onPersonClick}
            onDragStart={onPersonDragStart}
            compact
          />
        ))}
        {filteredUnassigned.length === 0 && unassigned.length > 0 && (
          <span style={{ fontSize: 12, color: "var(--ink-3)", fontStyle: "italic" }}>No matches</span>
        )}
        {unassigned.length === 0 && (
          <span style={{ fontSize: 12, color: "var(--ink-3)", fontStyle: "italic" }}>
            Every guest placed — well done.
          </span>
        )}
      </div>
    </div>
  );
}

export function GuestPoolSide({
  filteredUnassigned,
  unassigned,
  search, setSearch,
  addingPerson, setAddingPerson,
  newPerson, setNewPerson,
  onAddPerson,
  onDragOver, onDrop,
  selectedP,
  onPersonClick, onPersonDragStart,
}) {
  return (
    <div onDragOver={onDragOver} onDrop={onDrop} style={{
      width: 280, flexShrink: 0,
      borderRight: "1px solid var(--line)",
      background: "var(--paper-1)",
      display: "flex", flexDirection: "column",
      overflow: "hidden",
    }}>
      <div style={{ padding: "18px 18px 10px" }}>
        <Eyebrow>Still to seat · {unassigned.length}</Eyebrow>
      </div>
      <div style={{ padding: "0 14px 10px", display: "flex", flexDirection: "column", gap: 6 }}>
        <div style={{
          display: "inline-flex", alignItems: "center", gap: 8,
          padding: "7px 10px", borderRadius: 8,
          border: "1px solid var(--line-2)", background: "var(--paper-0)",
        }}>
          <I.search size={13} stroke="var(--ink-3)" />
          <input
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="Search…"
            style={{ flex: 1, border: "none", background: "transparent", outline: "none", fontSize: 12.5, color: "var(--ink)", fontFamily: "var(--ui)", minWidth: 0 }}
          />
        </div>
        {!addingPerson ? (
          <Btn variant="dashed" size="sm" icon={I.plus} style={{ width: "100%" }} onClick={() => setAddingPerson(true)}>
            Add guest
          </Btn>
        ) : (
          <>
            <input
              autoFocus
              value={newPerson}
              onChange={(e) => setNewPerson(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") onAddPerson();
                else if (e.key === "Escape") { setAddingPerson(false); setNewPerson(""); }
              }}
              placeholder="Full name"
              style={inputStyle}
            />
            <div style={{ display: "flex", gap: 4 }}>
              <Btn variant="primary" size="sm" style={{ flex: 1 }} onClick={onAddPerson}>Add</Btn>
              <Btn variant="quiet" size="sm" onClick={() => { setAddingPerson(false); setNewPerson(""); }}>Cancel</Btn>
            </div>
          </>
        )}
      </div>
      <div style={{ flex: 1, overflow: "auto", padding: "4px 14px 20px", display: "flex", flexDirection: "column", gap: 4 }}>
        {filteredUnassigned.map(p => (
          <div key={p.id} style={{ display: "block" }}>
            <Chip
              person={p}
              isSelected={selectedP === p.id}
              isHost={false}
              showHosts={false}
              onClick={onPersonClick}
              onDragStart={onPersonDragStart}
            />
          </div>
        ))}
        {filteredUnassigned.length === 0 && unassigned.length > 0 && (
          <span style={{ fontSize: 12, color: "var(--ink-3)", fontStyle: "italic" }}>No matches</span>
        )}
        {unassigned.length === 0 && (
          <span style={{ fontSize: 12, color: "var(--ink-3)", fontStyle: "italic" }}>
            Every guest placed.
          </span>
        )}
      </div>
    </div>
  );
}
